<div class="ui vertical basic segment">
  <div fxLayout="row" fxLayoutAlign="space-between center">
    <div fxLayoutAlign="start center" fxLayout="row" fxLayoutGap="20px">
      <!-- <div >
                    <img src="assets/icons/left-arrow-icon.svg" alt="">
                </div> -->
      <div class="equipment-id">
        <!-- Title -->
        <!-- <span class="sub-item">Settings / Manage Workflow</span> -->
        <h2 class="ui primary header">Company Users</h2>
      </div>
    </div>

    <div fxLayout="row" fxLayoutGap="15px">
      <button
        class="ui small basic blue button"
        suiPopup
        [popupInverted]="true"
        popupPlacement="bottom"
        popupText="Enable 2FA for all users"
      >
        <sui-checkbox
          class="toggle two_factor_setting_users_org"
          [(ngModel)]="organization.totpEnabled"
          (checkChange)="performAll2FA(organization)"
        >
          Enable 2FA for all users
        </sui-checkbox>
      </button>
      <button
        *isPermitted="{ id: 'USERS_MANAGEMENT', action: 'add' }"
        class="ui small primary button"
        (click)="popInviteUser()"
        suiPopup
        [popupInverted]="true"
        popupPlacement="bottom"
        popupText="add user"
      >
        Invite User
      </button>
    </div>
  </div>
  <div class="ui divider" appMargin marginY="3"></div>

  <div *ngIf="success || error" tamsyMargin marginY="10px">
    <esl-message-toast [(message)]="error"></esl-message-toast>
    <esl-message-toast
      [(message)]="success"
      [messageType]="'success'"
    ></esl-message-toast>
  </div>
</div>

<app-search-filter
  [filter]="usersParams"
  (onSearch)="searchRecords($event)"
  (onDisplayRows)="displayRecords($event)"
  (onSort)="sortRecords($event)"
></app-search-filter>
<!-- </div> -->
<div
  fxLayout="row"
  appMargin
  class="ui segment"
  marginB="3"
  fxLayoutGap="10px"
  fxLayoutAlign="start stretch"
  id="dark"
>
  <div fxFlex="3%">
    <sui-checkbox> </sui-checkbox>
  </div>
  <div fxFlex="15%">NAME</div>
  <div fxFlex="15%">USERNAME</div>
  <!-- <div  fxFlex="10%">NUMBER</div> -->
  <div fxFlex="15%">EMAIL</div>
  <div fxFlex="10%">ROLE</div>
  <!-- <div  fxFlex="12%">DEPARTMENT</div> -->
  <div fxFlex="12%">STATUS</div>
  <div fxFlex="15%">2FA</div>
  <div fxFlex="15%"></div>
</div>

<div class="ui vertical segment" [ngClass]="{ loading: pending }">
  <div
    class="ui segment"
    *ngFor="let user of users"
    appMargin
    marginB="3"
    fxLayout="row"
    fxLayoutGap="10px"
    fxLayoutAlign="start stretch"
  >
    <div fxFlex="3%">
      <sui-checkbox> </sui-checkbox>
    </div>
    <div fxFlex="15%">
      <span *ngIf="user.newUser === false">
        {{ user.firstName }} {{ user.lastName }} {{ user.middleName }}</span
      >
      <span class="ui blue mini label" *ngIf="user.newUser === true"
        >invitation sent</span
      >
    </div>
    <div fxFlex="15%">
      <span class="ui blue mini label" *ngIf="user.newUser === true"
        >invitation sent</span
      >
      <span *ngIf="user.newUser === false"> {{ user?.username }}</span>
    </div>
    <!-- <div fxFlex="10%">{{user?.mobileNumber}}</div> -->
    <div fxFlex="15%">{{ user?.appUserEmail }}</div>
    <div fxFlex="10%">{{ user?.roleId?.roleName }}</div>
    <!-- <div fxFlex="12%">{{user?.department}}</div> -->
    <div fxFlex="12%">
      <span class="ui red label" [ngClass]="{ green: user.active }">{{
        user?.active ? "ACTIVE" : "DEACTIVATED"
      }}</span>
    </div>
    <div fxFlex="15%">
      <sui-checkbox
        class="toggle two_factor_setting"
        [(ngModel)]="user.totpEnabled"
        [isDisabled]="organization.totpEnabled"
        (checkChange)="perform2FA(user)"
      >
      </sui-checkbox>
    </div>
    <div fxFlex="15%" class="text-right">
      <div class="ui small basic primary dropdown button" suiDropdown>
        <div class="text">Actions</div>
        <i class="dropdown icon"></i>
        <div class="left menu" suiDropdownMenu>
          <div
            class="item"
            (click)="viewUser(user)"
            *ngIf="checkPermission('USERS_MANAGEMENT', 'read')"
          >
            View User
          </div>
          <div
            class="item"
            (click)="deleteUser(user)"
            *ngIf="checkPermission('USERS_MANAGEMENT', 'remove')"
          >
            Remove User
          </div>
          <div
            class="item"
            (click)="reset2FA(user)"
            *ngIf="
              user.totpEnabled &&
              checkPermission('USERS_MANAGEMENT', 'edit') &&
              !organization.totpEnabled
            "
          >
            Reset 2FA
          </div>
          <div
            class="item"
            (click)="enable2FA(user)"
            *ngIf="
              !user.totpEnabled &&
              checkPermission('USERS_MANAGEMENT', 'edit') &&
              !organization.totpEnabled
            "
          >
            Enable 2FA
          </div>
          <div
            class="item"
            (click)="disable2FA(user)"
            *ngIf="
              user.totpEnabled &&
              checkPermission('USERS_MANAGEMENT', 'edit') &&
              !organization.totpEnabled
            "
          >
            Disable 2FA
          </div>
          <div
            class="item"
            (click)="roleModal(user)"
            *ngIf="checkPermission('USERS_MANAGEMENT', 'edit')"
          >
            Change Role
          </div>
          <div
            class="item"
            (click)="reactivateUser(user)"
            *ngIf="!user.active && checkPermission('USERS_MANAGEMENT', 'edit')"
          >
            Activate User
          </div>
          <div
            class="item"
            (click)="resendInvite(user)"
            *ngIf="user.newUser === true"
          >
            Resend Invite
          </div>
          <div
            class="item"
            (click)="deactivateUser(user)"
            *ngIf="user.active && checkPermission('USERS_MANAGEMENT', 'edit')"
          >
            Deactivate User
          </div>
          <div
            class="item"
            (click)="popAssignUser(user)"
            *ngIf="checkPermission('USERS_MANAGEMENT', 'edit')"
          >
            Assign Application
          </div>
        </div>
      </div>
      <!-- &nbsp;
									<button class="ui circular tiny button" (click)="viewUser(user)"><i class="eye icon"></i></button> -->
    </div>
  </div>
  <app-no-record-found *ngIf="users && users.length < 1"></app-no-record-found>
</div>

<div class="ui vertical basic segment">
  <div class="ui two column grid">
    <div class="column middle aligned">
      <div class="ui labeled button">
        <div class="ui tiny icon button" (click)="getPage(1)">
          <i class="refresh icon"></i>
        </div>
        <a class="ui basic label"> {{ totalItems }} Record(s) </a>
      </div>
    </div>
    <div class="column right aligned pagination menu" style="margin-left: auto">
      <sui-pagination
        class="small"
        [collectionSize]="totalItems"
        [pageSize]="rows"
        [maxSize]="maxSize"
        [hasEllipses]="false"
        [page]="currentPage"
        (pageChange)="nextPage($event)"
      >
      </sui-pagination>
    </div>
  </div>
</div>

<ng-template let-context let-modal="modal" #assignUserModalTemplate>
  <h3 class="ui primary header">
    <span>Application access for </span>
    <strong>{{ selectedUser.appUserEmail }} </strong>
    <i class="link times icon" (click)="modal.deny(undefined)"></i>
  </h3>
  <div class="content" *ngIf="selectedUser">
    <div
      class="scroll-wrapper ui basic segment"
      [ngClass]="{ loading: pending }"
    >
      <form #f="ngForm" novalidate>
        <div
          class="list-panel link"
          *ngFor="let application of applications"
          appMargin
          marginB="5"
          [ngClass]="{
            selected:
              checkApps(application.applicationId) ||
              application.applicationId === 'default'
          }"
        >
          <div
            fxLayout="row"
            fxLayoutAlign="space-between center"
            fxLayoutGap="15px"
          >
            <div fxFlex="auto">
              <!-- <sui-checkbox ></sui-checkbox> -->
              <input
                [checked]="
                  checkApps(application.applicationId) ||
                  application.applicationId === 'default'
                "
                [disabled]="application.applicationId === 'default'"
                [value]="application.allowed"
                name="application.applicationId"
                type="checkbox"
                (change)="
                  $event.target.checked
                    ? setApp('add', application.applicationId)
                    : setApp('remove', application.applicationId)
                "
              />
            </div>
            <div fxFlex="grow">
              <h4 class="sub-header">{{ application?.applicationName }}</h4>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="actions">
    <button class="ui basic primary button" (click)="modal.deny(undefined)">
      Cancel
    </button>
    <button class="ui primary button" (click)="modal.approve()" autofocus>
      Done
    </button>
  </div>
</ng-template>

<ng-template let-context let-modal="modal" #assignQuestionModalTemplate>
  <div class="content">
    <p>Would you like to assign application(s) to the user?</p>
  </div>
  <div class="actions">
    <button class="ui primary basic button" (click)="modal.deny('denied')">
      No
    </button>
    <button
      class="ui primary button"
      (click)="modal.approve('approved')"
      autofocus
    >
      Yes
    </button>
  </div>
</ng-template>

<ng-template let-context let-modal="modal" #copyInvitationModalTemplate>
  <div class="header">Copy Invitation Link</div>
  <div class="content">
    <p>Click on the button copy to copy the inivitation link.</p>
  </div>
  <div class="actions">
    <button class="ui basic button" (click)="modal.deny('denied')">
      Cancel
    </button>
    <button
      class="ui primary button"
      (click)="modal.approve('approved')"
      autofocus
    >
      Copy
    </button>
  </div>
</ng-template>

<ng-template let-context let-modal="modal" #roleModalTemplate>
  <h3 class="ui primary header">
    Change Role
    <i class="link times icon" (click)="modal.deny(undefined)"></i>
  </h3>
  <div class="content">
    <div
      class="scroll-wrapper ui basic segment"
      [ngClass]="{ loading: pending }"
    >
      <div class="ui form" [formGroup]="roleForm">
        <div class="field">
          <label>Select Role</label>
          <select
            class="ui fluid dropdown"
            [(ngModel)]="currentRole"
            placeholder="Select role"
            type="text"
            formControlName="role"
          >
            <option *ngFor="let opt of roles" [ngValue]="opt.roleId">
              {{ opt.roleName }}
            </option>
          </select>
        </div>
      </div>
    </div>
  </div>
  <div class="actions">
    <button class="ui basic primary button" (click)="modal.deny('denied')">
      Cancel
    </button>
    <button
      class="ui primary button"
      (click)="modal.approve('approved')"
      autofocus
    >
      Submit
    </button>
  </div>
</ng-template>

<ng-template let-context let-modal="modal" #inviteModalTemplate>
  <h3 class="ui primary header">
    Invite User
    <i class="link times icon" (click)="modal.deny(undefined)"></i>
  </h3>
  <div class="content">
    <div
      class="scroll-wrapper ui basic segment"
      [ngClass]="{ loading: pending }"
    >
      <div class="ui form" [formGroup]="userForm">
        <div class="field">
          <label>Email</label>
          <input
            placeholder="Enter email"
            type="text"
            formControlName="email"
          />
        </div>
        <div class="field">
          <label>Select Role</label>
          <select
            class="ui fluid dropdown"
            placeholder="Select role"
            type="text"
            formControlName="role"
          >
            <option *ngFor="let opt of roles" [ngValue]="opt.roleId">
              {{ opt.roleName }}
            </option>
          </select>
        </div>
      </div>
    </div>
  </div>
  <div class="actions">
    <button class="ui basic primary button" (click)="modal.deny('denied')">
      Cancel
    </button>
    <button
      class="ui primary button"
      [disabled]="!userForm.valid"
      (click)="modal.approve('approved')"
      autofocus
    >
      Submit
    </button>
  </div>
</ng-template>

<ng-template let-context let-modal="modal" #inviteMultipleModalTemplate>
  <h3 class="ui primary header">
    Invite Multiple Users
    <i class="link times icon" (click)="modal.deny(undefined)"></i>
  </h3>
  <div class="content">
    <div
      class="scroll-wrapper ui basic segment"
      [ngClass]="{ loading: pending }"
    >
      <div class="ui form" [formGroup]="multiUserForm">
        <div class="field required">
          <label>List Of Emails Separated by comma (,)</label>
          <input
            placeholder="Enter email address list"
            type="text"
            formControlName="emails"
          />
        </div>
        <div class="field required">
          <label>Select Role</label>
          <select
            class="ui fluid dropdown"
            placeholder="Select role"
            type="text"
            formControlName="role"
          >
            <option *ngFor="let opt of InviteRoles" [ngValue]="opt.roleId">
              {{ opt.roleName }}
            </option>
          </select>
        </div>
        <div class="field required">
          <label>Select Department</label>
          <select
            class="ui fluid dropdown"
            placeholder="Select role"
            type="text"
            formControlName="department"
          >
            <option
              *ngFor="let opt of InviteDepartments"
              [ngValue]="opt.organizationId"
            >
              {{ opt.organizationShortName }}
            </option>
          </select>
        </div>
        <div class="field required">
          <label>Select Application</label>
          <select
            class="ui fluid dropdown"
            placeholder="Select role"
            type="text"
            formControlName="application"
          >
            <option
              *ngFor="let application of inviteApplications"
              [ngValue]="application.applicationId"
            >
              {{ application.applicationName }}
            </option>
          </select>
        </div>
      </div>
    </div>
  </div>
  <div class="actions">
    <button class="ui basic primary button" (click)="modal.deny('denied')">
      Cancel
    </button>
    <button
      class="ui primary button"
      [disabled]="!userForm.valid"
      (click)="modal.approve('approved')"
      autofocus
    >
      Submit
    </button>
  </div>
</ng-template>
